import { createAction } from '@reduxjs/toolkit';

export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';

export const removeNotification = createAction(
    REMOVE_NOTIFICATION,
    (id: number) => ({ payload: id }),
);
